import React, { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";
import DriverPermissions from "../DriverPermissions";
import { readNativeLocationPermission } from "../utils/nativePermissions";
import { useNavigate, useParams } from "react-router-dom";
import { useContext } from "react";
import { UseContext } from "../context";
import nmp_mapboxgl from "@neshan-maps-platform/mapbox-gl";
import Modal from "react-modal";
import { MapComponent, MapTypes } from "@neshan-maps-platform/mapbox-gl-react";
import "@neshan-maps-platform/mapbox-gl-react/dist/style.css";
import "./Scroll.css";
import { notification } from "antd";
import axios from "axios";
import { url } from "../url";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import { getSocket, joinTravelRoom, leaveTravelRoom, sendDriverLocation, SOCKET_EVENTS } from "../socket";

import {
    IoArrowBack,
    IoCalendarOutline,
    IoTimeOutline,
    IoLocationOutline,
    IoNavigateOutline,
    IoPersonOutline,
    IoPeopleOutline,
    IoCallOutline,
    IoCheckmarkCircle,
    IoCloseCircle,
    IoChatbubbleEllipsesOutline,
    IoWalletOutline,
    IoMapOutline,
    IoInformationCircleOutline,
} from "react-icons/io5";

// ===== کامپوننت کمکی: ردیف اطلاعات =====
const InfoRow = ({ icon, label, value, iconBg = "bg-blue-50", iconColor = "text-blue-600" }) => (
    <div className="flex items-start gap-3 py-3">
        <div className={`w-9 h-9 rounded-lg ${iconBg} flex items-center justify-center flex-shrink-0 ${iconColor}`}>
            {icon}
        </div>
        <div className="flex-1 min-w-0">
            <p className="text-[11px] text-slate-500 mb-0.5">{label}</p>
            <div className="text-[14px] font-semibold text-slate-800 break-words">
                {value || "—"}
            </div>
        </div>
    </div>
);

// ===== کامپوننت کمکی: Badge وضعیت (اصلاح‌شده) =====
const StatusBadge = ({ status }) => {
    const config = {
        active: {
            label: "فعال",
            bg: "bg-emerald-50",
            color: "text-emerald-700",
            dot: "bg-emerald-500",
            pulse: true,
        },
        completed: {
            label: "انجام شده",
            bg: "bg-blue-50",
            color: "text-blue-700",
            dot: "bg-blue-500",
            pulse: false,
        },
        canceled: {
            label: "لغو شده",
            bg: "bg-red-50",
            color: "text-red-700",
            dot: "bg-red-500",
            pulse: false,
        },
    };

    const cfg = config[status] || config.active;

    return (
        <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full ${cfg.bg}`}>
            <span className="relative flex h-2 w-2">
                {cfg.pulse && (
                    <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${cfg.dot} opacity-75`}></span>
                )}
                <span className={`relative inline-flex rounded-full h-2 w-2 ${cfg.dot}`}></span>
            </span>
            <span className={`text-[12px] font-bold ${cfg.color}`}>{cfg.label}</span>
        </div>
    );
};

const EveryActivetrcard = () => {
    const travel = useParams();
    const navigate = useNavigate();

    const [showCancelModal, setShowCancelModal] = useState(false);
    const [locationRetry, setLocationRetry] = useState(0);

    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const { setShowhis, setShowtrinprogress } = useContext(UseContext);

    const [changecolorb, setChangecolorb] = useState(false);
    const [showsuccessmodal, setShowsuccessmodal] = useState(false);

    const closeshowsuccessmodal = () => {
        setShowsuccessmodal(false);
    };

    const openmodal = () => {
        setShowsuccessmodal(true);
    };

    const showsuccessmodalstyle = {
        content: {
            borderRadius: "16px",
            border: "none",
            padding: "0",
            overflow: "hidden",
            maxWidth: "400px",
            margin: "auto",
        },
        overlay: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(15, 23, 42, 0.5)",
            zIndex: 9999,
        },
    };

    const cancelModalStyle = {
        content: {
            borderRadius: "16px",
            height: "fit-content",
            width: window.innerWidth < 768 ? "85%" : "420px",
            zIndex: "9999",
            margin: "auto",
            border: "none",
            padding: "0",
            overflow: "hidden",
        },
        overlay: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(15, 23, 42, 0.5)",
            zIndex: 9999,
        },
    };

    useEffect(() => {
        setLoading(true);
        axios
            .get(`${url}/travel/v1/get-single-travel-driver/${travel.id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
            .then((res) => {
                setLoading(false);
                setData(res.data.data);
            })
            .catch((error) => {
                setLoading(true);
            });
    }, [travel.id]);

    // --- WebSocket: عضویت در room سفر + واکنش به لغو مسافر + ارسال موقعیت زنده ---
    useEffect(() => {
        const socket = getSocket();
        if (!socket || !travel.id) return;

        joinTravelRoom(travel.id);

        const isThisTravel = (payload) =>
            payload?.travel_id && String(payload.travel_id) === String(travel.id);

        const onCanceled = (payload) => {
            if (!isThisTravel(payload)) return;
            notification.info({
                message: "این سفر لغو شد",
                description: "سفر توسط مسافر یا پشتیبانی لغو شده است.",
            });
            navigate("/history");
        };

        socket.on(SOCKET_EVENTS.TRAVEL_CANCELED, onCanceled);
        return () => {
            socket.off(SOCKET_EVENTS.TRAVEL_CANCELED, onCanceled);
            leaveTravelRoom(travel.id);
        };
    }, [travel.id, navigate]);

    // GPS is started only while this active trip screen is mounted. A permission
    // change restarts GPS without disrupting the existing travel socket room.
    useEffect(() => {
        if (!getSocket() || !travel.id) return;
        let webWatcherId = null;
        let nativeWatcherId = null;
        let disposed = false;
        let lastSent = 0;
        const sendPosition = (pos) => {
            if (disposed || !pos) return;
            const now = Date.now();
            if (now - lastSent < 15000) return;
            lastSent = now;
            sendDriverLocation(travel.id, pos.coords.latitude, pos.coords.longitude);
        };

        if (Capacitor.isNativePlatform()) {
            (async () => {
                try {
                    const status = await readNativeLocationPermission();
                    if (disposed || status !== "granted") return;
                    const id = await Geolocation.watchPosition(
                        { enableHighAccuracy: true, maximumAge: 10000, timeout: 15000, minimumUpdateInterval: 15000 },
                        (position, error) => {
                            if (error) {
                                console.warn("Driver geolocation watch error.", error);
                                return;
                            }
                            sendPosition(position);
                        }
                    );
                    if (disposed) {
                        await Geolocation.clearWatch({ id });
                    } else {
                        nativeWatcherId = id;
                    }
                } catch (error) {
                    if (!disposed) console.warn("Unable to start native driver location updates.", error);
                }
            })();
        } else if (navigator.geolocation) {
            webWatcherId = navigator.geolocation.watchPosition(
                sendPosition,
                () => {},
                { enableHighAccuracy: true, maximumAge: 10000 }
            );
        }

        return () => {
            disposed = true;
            if (webWatcherId !== null && navigator.geolocation) {
                navigator.geolocation.clearWatch(webWatcherId);
            }
            if (nativeWatcherId !== null) {
                Geolocation.clearWatch({ id: nativeWatcherId }).catch((error) => {
                    console.warn("Unable to stop native driver location updates.", error);
                });
            }
        };
    }, [travel.id, locationRetry]);

    function handlefinishtravel() {
        axios
            .put(
                `${url}/travel/v1/finish-travel`,
                {
                    travel_id: travel.id,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            )
            .then((res) => {
                setChangecolorb(true);
                navigate("/history");
                window.location.reload();
            })
            .catch((error) => {
                if (error.response) {
                    notification.error({
                        message: "اتمام سفر با مشکل مواجه شد",
                        description: error.response.data.message,
                    });
                }
            });
    }

    const handlecloseeveryhiscom = () => {
        setShowtrinprogress(true);
        setShowhis(false);
        navigate("/history");
    };

    const cancelTravel = () => {
        axios
            .put(
                `${url}/travel/v1/cancel-travel-driver`,
                {
                    travel: travel.id,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            )
            .then((res) => {
                navigate("/history");
            })
            .catch((err) => {
                notification.error({
                    message: err.response.data.message,
                });
            });
    };

    useEffect(() => {
        if (data !== null && data.location) {
            const neshanMap = new nmp_mapboxgl.Map({
                mapType: nmp_mapboxgl.Map.mapTypes.neshanVector,
                container: "map",
                zoom: 7,
                pitch: 0,
                center: [data.location.longitude, data.location.latitude],
                minZoom: 2,
                maxZoom: 21,
                trackResize: true,
                mapKey: "web.7cc769b8dfb04fdcb6533c08ecd2b5b7",
                poi: true,
                traffic: false,
                isZoomControlsEnabled: true,
                setZoomGesturesEnabled: true,
                mapTypeControllerOptions: {
                    show: false,
                },
            });
            neshanMap.addControl(new nmp_mapboxgl.NavigationControl(), "top-right");
            new nmp_mapboxgl.Marker()
                .setLngLat([data.location.longitude, data.location.latitude])
                .addTo(neshanMap);
        }
    }, [data]);

    // Helper برای گرفتن اطلاعات مسافر (با fallback)
    const passengerInfo = data.passenger_snapshot || data.passenger || {};
    const passengerName = passengerInfo.full_name || "مسافر";
    const passengerMobile = passengerInfo.mobile || "";
    const passengerCount = data.passenger_count || 1;

    return (
        <>
            {localStorage.getItem("token") !== null ? (
                <>
                    {!loading ? (
                        data !== null ? (
                            /* ===== Layout جدید: ستونی با ناحیه وسط اسکرول‌شونده ===== */
                            <div className="h-full min-h-0 w-full flex flex-col bg-slate-50">

                                {/* ===== Header (ثابت بالا) ===== */}
                                <div className="flex-shrink-0 bg-white border-b border-slate-200 z-30">
                                    <div className="max-w-2xl mx-auto flex items-center gap-3 px-4 py-3">
                                        <button
                                            onClick={handlecloseeveryhiscom}
                                            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-slate-100 active:scale-95 transition-all"
                                            aria-label="بازگشت"
                                        >
                                            <IoArrowBack className="text-xl text-slate-700" />
                                        </button>
                                        <div className="flex-1 min-w-0">
                                            <h1 className="font-bold text-slate-800 text-base">جزئیات سفر</h1>
                                            <p className="text-[11px] text-slate-500">سفر در حال انجام</p>
                                        </div>
                                        <StatusBadge status={data.status} />
                                    </div>
                                </div>

                                {/* ===== محتوای اسکرول‌شونده ===== */}
                                <div className="flex-1 min-h-0 overflow-y-auto overscroll-contain" id="activescrollbar">
                                    <div className="max-w-2xl mx-auto px-4 pt-4 pb-6">
                                        <DriverPermissions
                                            locationOnly
                                            onLocationEnabled={() => setLocationRetry((previous) => previous + 1)}
                                        />

                                        {/* نقشه */}
                                        {data.location && (
                                            <div className="mb-4">
                                                <div className="relative rounded-xl overflow-hidden border border-slate-200 bg-white">
                                                    <div className="w-full h-[240px]">
                                                        <MapComponent
                                                            id="map"
                                                            options={{
                                                                mapKey: "web.7cc769b8dfb04fdcb6533c08ecd2b5b7",
                                                                mapType: MapTypes.neshanVector,
                                                                mapTypeControllerOptions: { show: false },
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="absolute top-3 right-3 bg-white px-3 py-1.5 rounded-lg border border-slate-200 flex items-center gap-1.5">
                                                        <IoMapOutline className="text-blue-600" />
                                                        <span className="text-[11px] font-semibold text-slate-700">موقعیت سفر</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* اطلاعات سفر */}
                                        <div className="bg-white rounded-xl border border-slate-200 p-5 mb-4">
                                            <div className="flex items-center gap-2 mb-3 pb-3 border-b border-slate-100">
                                                <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center text-white">
                                                    <IoInformationCircleOutline className="text-base" />
                                                </div>
                                                <h2 className="font-bold text-slate-800 text-[15px]">اطلاعات سفر</h2>
                                            </div>

                                            <div className="grid grid-cols-2 gap-x-4">
                                                <InfoRow
                                                    icon={<IoCalendarOutline className="text-base" />}
                                                    label="تاریخ سفر"
                                                    value={
                                                        <DatePicker
                                                            calendar={persian}
                                                            locale={persian_fa}
                                                            value={data.travel_date}
                                                            readOnly
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                outline: "none",
                                                                border: "none",
                                                                padding: 0,
                                                                fontSize: "14px",
                                                                fontWeight: 600,
                                                                color: "#1e293b",
                                                                width: "100%",
                                                            }}
                                                        />
                                                    }
                                                />
                                                <InfoRow
                                                    icon={<IoTimeOutline className="text-base" />}
                                                    label="ساعت سفر"
                                                    value={data.travel_hour_time}
                                                    iconBg="bg-amber-50"
                                                    iconColor="text-amber-600"
                                                />
                                            </div>

                                            <div className="my-3 border-t border-dashed border-slate-200"></div>

                                            <InfoRow
                                                icon={<IoLocationOutline className="text-base" />}
                                                label="مبدا"
                                                value={
                                                    <div>
                                                        <span>{data.origin_city?.name}</span>
                                                        {data.address && (
                                                            <span className="block text-[12px] text-slate-500 font-normal mt-0.5">
                                                                {data.address}
                                                            </span>
                                                        )}
                                                    </div>
                                                }
                                                iconBg="bg-emerald-50"
                                                iconColor="text-emerald-600"
                                            />

                                            <div className="flex justify-center py-1">
                                                <div className="w-px h-4 border-r-2 border-dashed border-slate-300"></div>
                                            </div>

                                            <InfoRow
                                                icon={<IoNavigateOutline className="text-base" />}
                                                label="مقصد"
                                                value={data.destination_city?.name}
                                                iconBg="bg-rose-50"
                                                iconColor="text-rose-600"
                                            />
                                        </div>

                                        {/* اطلاعات مسافر */}
                                        <div className="bg-white rounded-xl border border-slate-200 p-5 mb-4">
                                            <div className="flex items-center gap-2 mb-3 pb-3 border-b border-slate-100">
                                                <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center text-white">
                                                    <IoPersonOutline className="text-base" />
                                                </div>
                                                <h2 className="font-bold text-slate-800 text-[15px]">اطلاعات مسافر</h2>
                                            </div>

                                            <div className="flex items-center gap-3 mb-4">
                                                <div className="w-14 h-14 rounded-xl bg-indigo-600 flex items-center justify-center text-white text-xl font-bold flex-shrink-0">
                                                    {passengerName.charAt(0)}
                                                </div>
                                                <div className="flex-1 min-w-0">
                                                    <p className="text-[15px] font-bold text-slate-800 truncate">
                                                        {passengerName}
                                                    </p>
                                                    <p className="text-[12px] text-slate-500 flex items-center gap-1 mt-0.5">
                                                        <IoPeopleOutline className="text-xs" />
                                                        <span>{passengerCount} نفر</span>
                                                    </p>
                                                </div>
                                                {passengerMobile && (
                                                    <a
                                                        href={`tel:0${passengerMobile}`}
                                                        className="w-11 h-11 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600 hover:bg-emerald-100 active:scale-95 transition-all"
                                                        aria-label="تماس"
                                                    >
                                                        <IoCallOutline className="text-lg" />
                                                    </a>
                                                )}
                                            </div>

                                            {passengerMobile && (
                                                <div className="bg-slate-50 rounded-lg p-3 flex items-center justify-between">
                                                    <div className="flex items-center gap-2">
                                                        <IoCallOutline className="text-slate-500" />
                                                        <span className="text-[12px] text-slate-600">شماره تماس:</span>
                                                    </div>
                                                    <span
                                                        className="text-[14px] font-bold text-slate-800"
                                                        style={{ fontFamily: "IRANSansFaNum" }}
                                                    >
                                                        ۰{passengerMobile}
                                                    </span>
                                                </div>
                                            )}
                                        </div>

                                        {/* خالص دریافتی */}
                                        <div className="bg-emerald-600 rounded-xl p-5">
                                            <div className="flex items-center gap-2 mb-3">
                                                <div className="w-9 h-9 rounded-lg bg-white/20 flex items-center justify-center text-white">
                                                    <IoWalletOutline className="text-lg" />
                                                </div>
                                                <span className="text-white/90 text-[13px] font-medium">خالص دریافتی شما</span>
                                            </div>
                                            <div className="flex items-baseline gap-2">
                                                <span
                                                    className="text-[32px] font-bold text-white"
                                                    style={{ fontFamily: "IRANSansFaNum" }}
                                                >
                                                    {(data.price - (data.price_paid ?? 0)).toLocaleString("fa-IR")}
                                                </span>
                                                <span className="text-white/80 text-[14px] font-medium">تومان</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ===== نوار دکمه‌ها (ثابت پایین، داخل flow) ===== */}
                                <div className="flex-shrink-0 bg-white border-t border-slate-200 z-20">
                                    <div className="max-w-2xl mx-auto p-3 flex items-center gap-2">
                                        <button
                                            onClick={() => navigate(`/driverMessages/${data._id}`)}
                                            className="flex-1 h-12 rounded-xl bg-blue-600 text-white font-bold text-[13px] flex items-center justify-center gap-2 hover:bg-blue-700 active:scale-[0.98] transition-all"
                                        >
                                            <IoChatbubbleEllipsesOutline className="text-base" />
                                            پیام‌ها
                                        </button>
                                        <button
                                            onClick={openmodal}
                                            className="flex-1 h-12 rounded-xl bg-emerald-600 text-white font-bold text-[13px] flex items-center justify-center gap-2 hover:bg-emerald-700 active:scale-[0.98] transition-all"
                                            style={{
                                                backgroundColor: changecolorb ? "rgba(22, 43, 64, 1)" : undefined,
                                            }}
                                        >
                                            <IoCheckmarkCircle className="text-base" />
                                            اتمام سفر
                                        </button>
                                        {/* دکمه لغو سفر با متن مشخص */}
                                        <button
                                            onClick={() => setShowCancelModal(true)}
                                            className="h-12 px-4 rounded-xl bg-red-50 text-red-600 font-bold text-[13px] flex items-center justify-center gap-1.5 hover:bg-red-100 active:scale-[0.98] transition-all flex-shrink-0"
                                        >
                                            <IoCloseCircle className="text-lg" />
                                            لغو سفر
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            navigate("/history")
                        )
                    ) : (
                        <div className="h-screen bg-slate-50 flex items-center justify-center">
                            <div className="flex flex-col items-center gap-4">
                                <div className="w-20 h-20 rounded-full bg-blue-50 flex items-center justify-center">
                                    <div className="animate-spin rounded-full h-10 w-10 border-[3px] border-slate-200 border-t-blue-600"></div>
                                </div>
                                <p className="text-sm text-slate-500 font-medium">در حال بارگذاری...</p>
                            </div>
                        </div>
                    )}
                </>
            ) : (
                navigate("/")
            )}

            {/* ===== Modal: اتمام سفر ===== */}
            <Modal
                isOpen={showsuccessmodal}
                onRequestClose={closeshowsuccessmodal}
                style={showsuccessmodalstyle}
                className="modal-enter"
            >
                <div className="bg-white p-6">
                    <div className="flex justify-center mb-4">
                        <div className="w-20 h-20 rounded-full bg-emerald-50 flex items-center justify-center">
                            <IoCheckmarkCircle className="text-5xl text-emerald-600" />
                        </div>
                    </div>
                    <h3 className="text-[17px] font-bold text-slate-800 text-center mb-2">اتمام سفر</h3>
                    <p className="text-[13px] text-slate-500 text-center leading-6 mb-6">
                        آیا از اتمام این سفر مطمئن هستید؟
                    </p>
                    <div className="grid grid-cols-2 gap-3">
                        <button
                            onClick={closeshowsuccessmodal}
                            className="h-11 rounded-xl border-2 border-slate-200 text-slate-700 font-bold text-[14px] hover:bg-slate-50 active:scale-95 transition-all"
                        >
                            خیر
                        </button>
                        <button
                            onClick={handlefinishtravel}
                            className="h-11 rounded-xl bg-emerald-600 text-white font-bold text-[14px] hover:bg-emerald-700 active:scale-95 transition-all"
                        >
                            بله، تمام شد
                        </button>
                    </div>
                </div>
            </Modal>

            {/* ===== Modal: لغو سفر ===== */}
            <Modal
                isOpen={showCancelModal}
                onRequestClose={() => setShowCancelModal(false)}
                style={cancelModalStyle}
                className="modal-enter"
            >
                <div className="bg-white p-6">
                    <div className="flex justify-center mb-4">
                        <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center">
                            <IoCloseCircle className="text-5xl text-red-600" />
                        </div>
                    </div>
                    <h3 className="text-[17px] font-bold text-slate-800 text-center mb-2">لغو سفر</h3>
                    <p className="text-[13px] text-slate-500 text-center leading-6 mb-2">
                        آیا از لغو این سفر مطمئن هستید؟
                    </p>
                    <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-5">
                        <p className="text-[11px] text-amber-800 text-center leading-5">
                            ⚠️ توجه: در صورت لغو بیش از ۲ بار، حساب کاربری شما حذف خواهد شد.
                        </p>
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                        <button
                            onClick={() => setShowCancelModal(false)}
                            className="h-11 rounded-xl border-2 border-slate-200 text-slate-700 font-bold text-[14px] hover:bg-slate-50 active:scale-95 transition-all"
                        >
                            انصراف
                        </button>
                        <button
                            onClick={cancelTravel}
                            className="h-11 rounded-xl bg-red-600 text-white font-bold text-[14px] hover:bg-red-700 active:scale-95 transition-all"
                        >
                            بله، لغو شود
                        </button>
                    </div>
                </div>
            </Modal>

            {/* ===== CSS داخلی ===== */}
            <style>{`
                @keyframes modalEnter {
                    from {
                        opacity: 0;
                        transform: scale(0.95);
                    }
                    to {
                        opacity: 1;
                        transform: scale(1);
                    }
                }
                .modal-enter {
                    animation: modalEnter 0.2s ease-out both;
                }
            `}</style>
        </>
    );
};

export default EveryActivetrcard;